import { render, staticRenderFns } from "./IntermediateCert.vue?vue&type=template&id=06639200"
import script from "./IntermediateCert.vue?vue&type=script&lang=js"
export * from "./IntermediateCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports